import { ColDef } from 'ag-grid-community';
import { createIdCol, createTextInputCol } from '@/src/helpers/agColumnHelper';
import { UseFormReturn } from 'react-hook-form';

const valueFormatter = (value: string): string => {
  if (value === undefined || value.length === 0) return '';

  // 숫자와 소수점만 추출한다.
  const extractVal = value?.toString().replace(/[^\d.]/g, '');

  if (extractVal.length === 0) return '';

  // 소수점이 2개 이상일 경우 제거 한다.
  // 소수점이 숫자의 앞에 올 수 없다.
  const filteredVal = extractVal
    .replace(/(\..*)\./g, '$1')
    .replace(/^\.+/g, '');

  return filteredVal;
};

export const optionFormColumn = ({
  form,
  tableField,
}: {
  form: UseFormReturn<any>;
  tableField?: string;
}): ColDef[] => [
  createIdCol(),
  createTextInputCol({
    field: 'size',
    placeholder: '옵션 명을 입력해주세요',
    form,
    tableField,
    headerName: '옵션 명',
  }),
  createTextInputCol({
    field: 'weight',
    placeholder: '무게를 입력해주세요',
    valueFormatter,
    form,
    tableField,
    headerName: '무게(g)',
  }),
  createTextInputCol({
    field: 'carbonEmissionReduction',
    placeholder: '탄소 감축량을 입력해주세요',
    valueFormatter,
    form,
    tableField,
    headerName: '탄소 감축량(g)',
  }),
  createTextInputCol({
    field: 'pineScore',
    placeholder: '소나무 지수를 입력해주세요',
    valueFormatter,
    form,
    tableField,
    headerName: '소나무 지수',
  }),
];
